<template>
  <rv-radio :name="name" :label="label" :option-a="true" :option-b="false" v-model="data" v-on:input="update" :validation-rule="validationRule"/>
</template>

<script>
import RvRadio from '../RvRadio'

export default {
  props: ['value'],
  components: { RvRadio },
  data() {
    return {
      label: 'Do you have a partner who will live with you in the village?',
      name: 'isCouple',
      data: this.value,
      validationRule: {
        required: true,
        in: [true, false]
      }
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.data)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modules/inputs/basic-information/IsCouple.vue